module.exports = __webpack_public_path__ + "img/icon-sb-low-alert-orange-boutique-48x48.10ffd00.svg";